import { createFeatureSelector } from '@ngrx/store';
import * as FusionAuth from './state/fusion-auth.state';

export interface AppState {
    authState: FusionAuth.State;
}

export const reducers = {
    auth: FusionAuth.reducer,
};

export const selectAuthState = createFeatureSelector<AppState>('auth');
